<div class="container bg-whitesmoke py-4">
  <app-breadcrumb></app-breadcrumb>
  
  <div class="edit-card-container">
  <!-- Loading State -->
  <div *ngIf="loading" class="loading-state">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading card details...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error" class="error-state">
    <mat-icon class="error-icon">error</mat-icon>
    <h6 class="error-title">Error Loading Card</h6>
    <p class="error-message">{{ error }}</p>
    <button mat-button (click)="loadCard()" class="retry-btn">
      <mat-icon class="me-1">refresh</mat-icon>
      Try Again
    </button>
  </div>

  <!-- Card Not Found -->
  <div *ngIf="!loading && !error && !card" class="no-card-state">
    <mat-icon class="no-card-icon">warning</mat-icon>
    <h4>Card Not Found</h4>
    <p>The card you're trying to edit does not exist or you don't have access.</p>
    <button mat-raised-button (click)="navigateBack()">Go Back</button>
  </div>

  <!-- Edit Form (Only when card is loaded) -->
  <div *ngIf="!loading && !error && card" class="edit-form">

    <!-- Logo Upload Section -->
    <section class="edit-section mb-4">
      <!-- <div
    class="section-header d-flex justify-content-between align-items-center"
    (click)="toggleSection('logo')"
  >
    <h3>🖼 Logo</h3>
    <mat-icon class="section-toggle-icon">
      {{ expandedSection === 'logo' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </mat-icon>
  </div> -->

      <!-- Centered Logo Edit (no dropdown/section header) -->
      <div class="logo-edit-center">
        <h3 class="logo-title">Logo</h3>

        <div class="logo-preview" [ngClass]="logoShape">
          <img *ngIf="logoUrl" [src]="logoUrl" alt="Logo" />
          <mat-icon *ngIf="!logoUrl">image</mat-icon>
          <!-- tiny edit button to open file picker -->
          <!-- <button mat-fab color="primary" class="logo-edit-fab" (click)="logoInput.click()">
      <mat-icon>edit</mat-icon>
    </button> -->
        </div>

        <input type="file" (change)="onLogoSelected($event)" accept="image/*" hidden #logoInput />

        <div class="logo-actions">
          <button mat-stroked-button (click)="logoInput.click()">Upload Logo</button>

          <mat-button-toggle-group [(ngModel)]="logoShape" (change)="saveLogoShape()" name="logoShape"
            aria-label="Logo Shape" class="shape-toggle">
            <mat-button-toggle value="square">Square</mat-button-toggle>
            <mat-button-toggle value="circle">Circle</mat-button-toggle>
          </mat-button-toggle-group>
        </div>

        <div *ngIf="uploadingLogo" class="w-100 mt-2">
          <mat-progress-bar mode="determinate" [value]="uploadProgress"></mat-progress-bar>
          <p class="text-muted mt-1 small">Uploading... {{ uploadProgress | number:'1.0-0' }}%</p>
        </div>
      </div>
    </section>

    <!-- End Logo Upload Section -->

    <!-- Contact Information Section -->
    <section class="edit-section mb-4">
  <div class="section-header" (click)="toggleSection('contact')">
    <h3><mat-icon class="me-1">apartment</mat-icon> About & Business Details</h3>
    <mat-icon class="section-toggle-icon">
      {{ expandedSection === 'contact' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </mat-icon>
  </div>

  <div *ngIf="expandedSection === 'contact'" class="section-content">
    <form (ngSubmit)="saveContact()" #contactForm="ngForm">
      <div class="form-grid d-grid gap-3">
         <!-- 🏢 Company Name -->
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Company Name</mat-label>
          <input
            matInput
            [(ngModel)]="contactFormValues.companyName"
            name="companyName"
            required
            placeholder="Example Pvt. Ltd." />
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Company Email</mat-label>
          <input matInput [(ngModel)]="contactFormValues.companyEmail" name="companyEmail" required placeholder="company@example.com">
          <mat-icon matSuffix>email</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Company Phone</mat-label>
          <span matPrefix>+91&nbsp;</span>
          <input
            matInput
            [(ngModel)]="contactFormValues.companyPhone"
            name="companyPhone"
            required
            placeholder="12345 67890"
            (ngModelChange)="addPrefix()" />
          <mat-icon matSuffix>phone</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Company Website</mat-label>
          <input matInput [(ngModel)]="contactFormValues.companyWebsite" name="companyWebsite" placeholder="https://example.com">
          <mat-icon matSuffix>public</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Address</mat-label>
          <textarea matInput rows="2" [(ngModel)]="contactFormValues.address" name="address" placeholder="123 Main St, City, Country"></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Description</mat-label>
          <textarea matInput rows="3" [(ngModel)]="contactFormValues.description" name="description" placeholder="Brief description"></textarea>
        </mat-form-field>
      </div>

      <div class="section-actions mt-3">
        <button type="submit" mat-raised-button [disabled]="contactSaving || !contactForm.valid" class="save-btn">
          <div class="btn-content d-flex align-items-center gap-2">
            <mat-spinner *ngIf="contactSaving" diameter="20"></mat-spinner>
            <mat-icon *ngIf="!contactSaving">save</mat-icon>
            <span>{{ contactSaving ? 'Saving...' : 'Save Contact Info' }}</span>
          </div>
        </button>
      </div>
    </form>
  </div>
</section>
    <!-- Business Information Section -->
    <section class="edit-section mb-4">
  <div class="section-header" (click)="toggleSection('business')">
    <h3><mat-icon class="me-1">storefront</mat-icon> Business Contact Information</h3>
    <mat-icon class="section-toggle-icon">
      {{ expandedSection === 'business' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </mat-icon>
  </div>

  <div *ngIf="expandedSection === 'business'" class="section-content">
    <form (ngSubmit)="saveBusinessInfo()" #businessForm="ngForm">
      <div class="form-grid d-grid gap-3">
        <!-- 🔁 Contact fields moved here -->
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Full Name</mat-label>
          <input matInput [(ngModel)]="businessFormValues.name" name="name" required placeholder="John Doe">
          <mat-icon matSuffix>person</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Email</mat-label>
          <input matInput type="email" [(ngModel)]="businessFormValues.email" name="email" required placeholder="john@example.com">
          <mat-icon matSuffix>email</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Phone</mat-label>
          <input matInput [(ngModel)]="businessFormValues.phone" name="phone" required placeholder="+1 234 567 8900">
          <mat-icon matSuffix>phone</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Department</mat-label>
          <input matInput [(ngModel)]="businessFormValues.department" name="department" placeholder="Sales, Marketing...">
          <mat-icon matSuffix>apartment</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Job Title</mat-label>
          <input matInput [(ngModel)]="businessFormValues.jobTitle" name="jobTitle" placeholder="Manager, Developer...">
          <mat-icon matSuffix>work</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>WhatsApp Number</mat-label>
          <input matInput [(ngModel)]="businessFormValues.whatsappNumber" name="whatsappNumber" placeholder="+1 234 567 8900">
          <mat-icon matSuffix>whatsapp</mat-icon>
        </mat-form-field>
      </div>

      <div class="section-actions mt-3">
        <button type="submit" mat-raised-button color="primary" [disabled]="businessSaving || !businessForm.valid" class="save-btn">
          <div class="btn-content d-flex align-items-center gap-2">
            <mat-spinner *ngIf="businessSaving" diameter="20"></mat-spinner>
            <mat-icon *ngIf="!businessSaving">save</mat-icon>
            <span>{{ businessSaving ? 'Saving...' : 'Save Business Info' }}</span>
          </div>
        </button>
      </div>
    </form>
  </div>
</section>

    <section class="edit-section mb-4">
      <div class="section-header" (click)="toggleSection('socialLinks')">
        <h3><mat-icon class="me-1">public</mat-icon> Social Links</h3>
        <mat-icon class="section-toggle-icon">{{ expandedSection === 'socialLinks' ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
          }}</mat-icon>
      </div>

      <div *ngIf="expandedSection === 'socialLinks'" class="section-content">
        <div *ngFor="let link of socialLinks; let i = index" class="form-grid d-grid gap-3 align-items-center">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Platform</mat-label>
            <mat-select [(ngModel)]="link.platform" name="social-platform-{{i}}">
              <mat-option value="LinkedIn">LinkedIn</mat-option>
              <mat-option value="Twitter">Twitter</mat-option>
              <mat-option value="Facebook">Facebook</mat-option>
              <mat-option value="Instagram">Instagram</mat-option>
              <mat-option value="YouTube">YouTube</mat-option>
              <mat-option value="GitHub">GitHub</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>URL</mat-label>
            <input matInput [(ngModel)]="link.url" name="social-url-{{i}}" placeholder="https://...">
          </mat-form-field>
          <button mat-icon-button color="warn" (click)="removeSocialLink(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <div class="section-actions mt-3 d-flex gap-2">
          <button mat-stroked-button (click)="addSocialLink()"><mat-icon>add</mat-icon> Add Social Link</button>
          <button mat-raised-button color="primary" (click)="saveSocialLinks()">Save Social Links</button>
        </div>
      </div>
    </section>

    <!-- Quick Links Section -->
    <section class="edit-section mb-4">
      <div class="section-header" (click)="toggleSection('quickLinks')">
        <h3><mat-icon class="me-1">open_in_new</mat-icon> Quick Links</h3> <mat-icon class="section-toggle-icon">{{
          expandedSection === 'quickLinks' ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
          }}</mat-icon>
      </div>

      <div *ngIf="expandedSection === 'quickLinks'" class="section-content">
        <div *ngFor="let link of quickLinks; let i = index" class="form-grid d-grid gap-3 align-items-center">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Title</mat-label>
            <input matInput [(ngModel)]="link.title" name="quick-title-{{i}}" placeholder="Link title">
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>URL</mat-label>
            <input matInput [(ngModel)]="link.url" name="quick-url-{{i}}" placeholder="https://...">
          </mat-form-field>
          <button mat-icon-button color="warn" (click)="removeQuickLink(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <div class="section-actions mt-3 d-flex gap-2">
          <button mat-stroked-button (click)="addQuickLink()"><mat-icon>add</mat-icon> Add Quick Link</button>
          <button mat-raised-button color="primary" (click)="saveQuickLinks()">Save Quick Links</button>
        </div>
      </div>
    </section>

  
    <!-- Entities Section -->
     <section class="edit-section mb-4">
  <div class="section-header" (click)="toggleSection('entities')">
    <h3>
      <mat-icon>folder_shared</mat-icon> Entities
    </h3>
    <mat-icon class="section-toggle-icon">
      {{ expandedSection === 'entities' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </mat-icon>
  </div>

 <div *ngIf="expandedSection === 'entities'" class="section-content">
  <div
    *ngFor="let entity of entities; let i = index"
    class="form-grid d-grid gap-3 align-items-center"
  >
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Entity Name</mat-label>
      <input
        matInput
        [(ngModel)]="entity.name"
        name="entity-name-{{ i }}"
        placeholder="Enter entity name"
      />
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Entity Domain URL</mat-label>
      <input
        matInput
        [(ngModel)]="entity.domainUrl"
        name="domainUrl-{{ i }}"
        placeholder="Enter Entity domainUrl"
        type="url"
      />
    </mat-form-field>

      <button mat-icon-button color="warn" (click)="removeEntity(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>

    <div class="section-actions mt-3 d-flex gap-2">
      <button mat-stroked-button (click)="addEntity()">
        <mat-icon>add</mat-icon> Add Entity
      </button>
      <button mat-raised-button color="primary" (click)="saveEntities()">
        Save Entities
      </button>
    </div>
  </div>
</section>

<!-- leaders -->
<!-- <section class="edit-section mb-4">
  <div class="section-header" (click)="toggleSection('leaders')">
    <h3>
      <mat-icon>supervisor_account</mat-icon> Leaders
    </h3>
    <mat-icon class="section-toggle-icon">
      {{ expandedSection === 'leaders' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </mat-icon>
  </div>

  <div *ngIf="expandedSection === 'leaders'" class="section-content">
    <div *ngFor="let leader of leaders; let i = index" class="form-grid d-grid gap-3 align-items-center">

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Leader Name</mat-label>
        <input
          matInput
          [(ngModel)]="leader.name"
          name="leader-name-{{ i }}"
          placeholder="Enter leader name"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Role/Position</mat-label>
        <input
          matInput
          [(ngModel)]="leader.role"
          name="leader-position-{{ i }}"
          placeholder="Enter leader role"
        />
      </mat-form-field>

      <button
        mat-icon-button
        color="warn"
        (click)="removeLeader(i)"
        matTooltip="Remove leader"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>

    <button mat-raised-button color="primary" class="mt-3" (click)="addLeader()">
      <mat-icon>add</mat-icon> Add Leader
    </button>

    <button mat-stroked-button color="accent" class="mt-3 ms-2" (click)="saveLeaders()">
      <mat-icon>save</mat-icon> Save Leaders
    </button>
  </div>
</section> -->

<!-- branches -->
<section class="edit-section mb-4">
  <div class="section-header" (click)="toggleSection('branches')">
    <h3><mat-icon class="me-1" aria-hidden="true">location_city</mat-icon> Branches</h3>
    <mat-icon class="section-toggle-icon">
      {{ expandedSection === 'branches' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </mat-icon>
  </div>

  <div *ngIf="expandedSection === 'branches'" class="section-content">
    <div *ngFor="let branch of branches; let i = index" class="form-grid d-grid gap-3 align-items-center">
      
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>City</mat-label>
        <input matInput [(ngModel)]="branch.city" name="branch-city-{{i}}" placeholder="Enter city">
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Address</mat-label>
        <input matInput [(ngModel)]="branch.address" name="branch-address-{{i}}" placeholder="Enter address">
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Pincode</mat-label>
        <input matInput type="number" [(ngModel)]="branch.pincode" name="branch-pincode-{{i}}" placeholder="Enter pincode">
      </mat-form-field>

      <button mat-icon-button color="warn" (click)="removeBranch(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>

    <div class="section-actions mt-3 d-flex gap-2">
      <button mat-stroked-button (click)="addBranch()">
        <mat-icon>add</mat-icon> Add Branch
      </button>
      <button mat-raised-button color="primary" (click)="saveBranches()">
        Save Branches
      </button>
    </div>
  </div>
</section>


<!-- permissions -->
<section class="edit-section mb-4">
  <div class="section-header" (click)="toggleSection('permissions')">
    <h3>
      <mat-icon>shield</mat-icon> Permissions
    </h3>
    <mat-icon class="section-toggle-icon">
      {{ expandedSection === 'permissions' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </mat-icon>
  </div>

  <div *ngIf="expandedSection === 'permissions'" class="section-content">
    <div class="permission-item d-flex align-items-center justify-content-between mb-3">
  <span>Show Analytical</span>
  <mat-slide-toggle
    [checked]="permissions.show_Analytical === 'show'"
    (change)="permissions.show_Analytical = $event.checked ? 'show' : 'hide'"
    color="primary"
  >
    {{ permissions.show_Analytical }}
  </mat-slide-toggle>
</div>

<div class="permission-item d-flex align-items-center justify-content-between mb-3">
  <span>Show Payment Methods</span>
  <mat-slide-toggle
    [checked]="permissions.Show_Payment_Methods === 'show'"
    (change)="permissions.Show_Payment_Methods = $event.checked ? 'show' : 'hide'"
    color="primary"
  >
    {{ permissions.Show_Payment_Methods }}
  </mat-slide-toggle>
</div>


    <button
      mat-stroked-button
      color="accent"
      class="mt-3"
      (click)="savePermissions()"
    >
      <mat-icon>save</mat-icon> Save Permissions
    </button>
  </div>
</section>


    <!-- Theme Selection -->
    <section class="edit-section mb-4">
      <div class="section-header d-flex justify-content-between align-items-center" (click)="toggleSection('theme')">
       <h3><mat-icon class="me-1">color_lens</mat-icon> Theme Settings</h3>
        <mat-icon class="section-toggle-icon">
          {{ expandedSection === 'theme' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </mat-icon>
      </div>

      <div *ngIf="expandedSection === 'theme'" class="section-content">
        <button mat-stroked-button color="primary" (click)="openThemePicker()" [disabled]="!card">
          <mat-icon>palette</mat-icon>
          Change Theme
        </button>
      </div>
    </section>


    <!-- Delete Card Section -->
    <!-- Delete Card Section -->
    <!-- <section class="edit-section mb-4">
  <div class="section-header d-flex justify-content-between align-items-center"
       (click)="toggleSection('delete')">
    <h3>🗑 Delete Card</h3>
    <mat-icon class="section-toggle-icon">
      {{ expandedSection === 'delete' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </mat-icon>
  </div>

 
</section> -->
    <div class="section-content d-flex justify-content-center">
      <button mat-raised-button color="warn" (click)="confirmDeleteCard()">
        <mat-icon>delete_forever</mat-icon>
        Delete Card
      </button>
    </div>

  </div>
  </div>
</div>